import { useNavigate } from "react-router-dom";
import EventsForm from "components/events/EventsForm";
import { useEvents } from "components/events/hooks/useEvents";
import Alert from "components/common/Alert";
import { useState } from "react";

export default function CreateEvent() {
  const navigate = useNavigate();
  const { addEvent } = useEvents();

  const [alert, setAlert] = useState(null);

  const companyId = localStorage.getItem("company_id");
  const userId = "69579c6190a653b640e65639";

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
  
      <EventsForm
        onSubmit={async (fd) => {
        try {
            fd.append("company_id", companyId);
            fd.append("created_by", userId);

            await addEvent(fd);

            navigate("/admin/events");
        } catch (error) {
            setAlert({
            type: "error",
            message:
                error.response?.data?.message ||
                "Failed to create event",
            });
        }
        }}
        onBack={() => navigate("/admin/events")}
      />
    </>
  );
}
